import request from './index';

export function getDetailpage(params) {
  return request.get('officialPageObject/page', {
    params: params
  });
}

